export const checkIn = require('./check-in.png');
export const checkOut = require('./check-out.png');